import Vue from 'vue'
import axios from "axios";
import jwtDecode from 'jwt-decode'

const getStatusOrders = () => {
  let statusOrders = [
    {id: '', name: 'Todos'},
    {id: 'pen', name: 'Pendiente'},
    {id: 'apr', name: 'Aprobado'},
    {id: 'ent', name: 'Entregado'},
    {id: 'can', name: 'Cancelado'},
    {id: 'env', name: 'Enviado'},
  ]
  return statusOrders
}

const getStatusPickups = () => {
  let statusOrders = [
    {id: '', name: 'Todos'},
    {id: 'pen', name: 'Pendiente'},
    {id: 'apr', name: 'Aprobado'},
    {id: 'recog', name: 'Recogido'},
    {id: 'can', name: 'Cancelado'},]
  return statusOrders
}

const getStatusDigitalization = () => {
  let statusOrders = [
    {id: '', name: 'Todos'},
    {id: 'req', name: 'Requerido'},
    {id: 'comp', name: 'Completado'},
    {id: 'dis', name: 'Desaprobado'},
    {id: 'canc', name: 'Cancelado'},
  ]
  return statusOrders
}

const getStatusInquiries = () => {
  let statusOrders = [
    {id: 'req', name: 'Pendiente'},
    {id: 'comp', name: 'Completado'},
    {id: 'canc', name: 'Cancelado'},
    {id: 'dis', name: 'Desaprobado'},
    {id: 'fina', name: 'Finalizado'},
    {id: 'apr', name: 'Aprobado'}
  ]
  return statusOrders
}

const getAxiosInstance = () => {
  const endpoint = __API__
  Vue.prototype.$endpoint = endpoint
  const axiosInstance = axios.create({
    baseURL: endpoint,
    timeout: 600000,
  })

  return axiosInstance;
}

const checkAuth = () => {
  const token = localStorage.getItem('token');
  if (!token) return false;

  const decoded = jwtDecode(token);
  const expired = new Date() > new Date(decoded.expires);

  if (expired) {
    localStorage.clear();
    window.dispatchEvent(new Event("session-expired"));
    return false;
  }

  return true;
}

const getAuth = () => {
  const token = localStorage.getItem('token');
  return jwtDecode(token);
}

const getAuthHeader = () => {
  return {
    'Authorization': 'Bearer ' + localStorage.getItem('token')
  }
}

const getAuthHeaderMultipart = () => {
  return {
    'Authorization': 'Bearer ' + localStorage.getItem('token'),
    'content-type': 'multipart/form-data'
  }
}

const isAccess = (access) => {
  var accessList = []
  if (checkAuth()) {
    accessList = getAuth().access
  }
  return accessList.find(a => a === access)
}

const showDialogError = (context, message) => {
  context.$dialog.alert({
    title: 'Error',
    message,
    type: 'is-danger',
    hasIcon: true,
    icon: 'alert-circle',
  })
}

const getUser = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : {}; // Devolvemos objeto vacío si no hay usuario
}

const isOnlyVaultUser = () => {
  const allowedStorageModes = getUser().allowedStorageModes;

  return Array.isArray(allowedStorageModes)
    && allowedStorageModes.length === 1
    && allowedStorageModes[0] === 'VAULT';
}

const getAccessByCode = (code) => {
  const menus = localStorage.getItem("menus");
  if (!menus) return undefined;

  let accessList = JSON.parse(menus);
  return accessList.find(access => access.code === code)
}

const getLocationName = (id) => {
  let locationList = JSON.parse(localStorage.getItem("location"));

  let ctrl = true;
  let idTemp = id;
  const name = [];

  while (ctrl === true) {
    const location = locationList.find(l => l.id === idTemp);
    if (location.isRoot === true) {
      ctrl = false
    } else {
      idTemp = location.parent
      name.push(`${location.type.toString().substr(0, 3)} ${location.name}`)
    }
  }

  return name.reverse().join("/")
}

const getLocationObject = (id) => {
  if (!id)
    return null

  let locationList = JSON.parse(localStorage.getItem("location"));

  let ctrl = true;
  let idTemp = id;
  const name = [];

  while (ctrl === true) {
    const location = locationList.find(l => l.id === idTemp);
    if (location.isRoot === true) {
      ctrl = false
    } else {

      idTemp = location.parent
      name.push(`${location.type.toString().substr(0, 3)} ${location.name}`)
    }
  }

  return {id, 'name': name.reverse().join("/")}
}

const getBillingServiceByCode = (code) => {
  const billingServices = JSON.parse(localStorage.getItem("billingServices"))
  return billingServices.find(value => value.code === code)
}

const getBillingServiceList = () => {
  const billingServices = JSON.parse(localStorage.getItem("billingServices"))
  return billingServices
}

const getClient = (id) => {
  const clientsStr = localStorage.getItem("clients");
  if (!clientsStr) return {};

  let clients = JSON.parse(clientsStr);
  let client = clients.find(c => c.id === id)
  if (client)
    return client
  else return {}
}

const getClientAddress = () => {
  let client = JSON.parse(localStorage.getItem("clients"));
  if (!client)
    return []

  if (client.addresses) {
    let addressList = []
    client.addresses.forEach(dic => {
      addressList.push(`${dic.description} - ${dic.district}`)
    })
    return addressList
  } else {
    return []
  }

}

const getDepartaments = () => {
  let departaments = JSON.parse(localStorage.getItem("departaments"));
  return departaments;
}

const getProvinces = (codeDepartament) => {
  let provinces = JSON.parse(localStorage.getItem("provinces"));
  let provincesFilter = provinces.filter(c => c.codeDepartament === codeDepartament)
  return provincesFilter;
}

const getDistricts = (codeDepartament, codeProvince) => {
  let districts = JSON.parse(localStorage.getItem("districts"));
  let districtsFilter = districts.filter(c => c.codeDepartament === codeDepartament && c.codeProvince === codeProvince)
  return districtsFilter;
}

const CLIENT_DEFAULT_CODE = "FILEKOM_CLIENT"

export default {
  checkAuth,
  getAuth,
  getAuthHeader,
  getAuthHeaderMultipart,
  showDialogError,
  getUser,
  isOnlyVaultUser,
  getAccessByCode,
  getAxiosInstance,
  getLocationName,
  getLocationObject,
  getClient,
  getClientAddress,
  isAccess,
  getBillingServiceByCode,
  getBillingServiceList,
  CLIENT_DEFAULT_CODE,
  getStatusPickups,
  getStatusDigitalization,
  getDepartaments,
  getProvinces,
  getDistricts,
  getStatusInquiries,
  getStatusOrders
}



// WEBPACK FOOTER //
// ./src/util/index.js